export default __webpack_public_path__ + "static/media/crossroads8.9d870d4c.webp";